import styled from 'styled-components'

export const Options = styled.div`
  height: 32px;
  button {
    float: right;
    padding: 0 8px;
    color: #4c4c4c !important;
    border-radius: 8px;
    background-color: #f0f0f0 !important;
    svg {
      transition: 200ms;
    }
    &:hover > svg {
      opacity: 0.5;
    }
    &:disabled {
      color: #4c4c4c !important;
      opacity: 0.48;
    }
  }
`

export const AddCourse = styled.div`
  button {
    color: #2684ff;
    height: 40px;
    margin-top: 8px;
    font-weight: 700;
    svg {
      margin-right: 8px;
    }
  }
`

export const Alert = styled.div`
  color: #363636;
  padding: 16px;
  border-radius: 8px;
  background-color: #e7f3fe;
  margin-bottom: 16px;
  position: relative;
  svg {
    color: #213f68;
    font-size: 14px;
    margin: 0 4px;
    position: absolute;
    margin-top: 5px;
  }
  span {
    font-weight: bold;
  }
`

export const AlertContent = styled.div`
  padding-left: 30px;
`

export const Observations = styled.div`
  color: #363636;
  margin-bottom: 24px;
  span {
    font-weight: bold;
  }
`
